import chartBuilderBase from "./chartBuilderBase.js";
import seriesBuilder from "./seriesBuilder.js";

/**
 * Builds scatter series options http://api.highcharts.com/highcharts#series
 *
 * @param {object} spec - Parameter object
 * @param {object} my - protected fields holder
 * @return {{}}
 */
function scatterSeriesBuilder(spec, my) {
	spec ||= {};
	my ||= {};

	const builderSpec = Object.create(spec);

	builderSpec.options = chartBuilderBase.mergeOptions(
		builderSpec.options || {},
		{
			borderWidth: 0,
			type: "scatter",
			lineWidth: 3,
		},
	);

	const that = seriesBuilder(builderSpec, my);
	my.myself = that;

	return that;
}

export default scatterSeriesBuilder;
